import React from "react";
import {Controller} from 'react-hook-form'
import {Label, Input} from 'reactstrap'
import ValidationMsgComponent from "../ValidationMsgComponent";
// import {isDisabled} from "bootstrap/js/src/util";

const ControlledTextAreaField = ({label, inputName, placeholder, invalid, control, rules, errors, rowCount, isDisabled}) => {
    return (
        <div className='mb-1'>
            <Label className='form-label' htmlFor={inputName}>
                {label}
            </Label>
            <Controller
                name={inputName}
                control={control}
                rules={rules}
                render={({field}) => (
                    <Input
                        id={inputName}
                        type="textarea"
                        placeholder={placeholder}
                        invalid={invalid}
                        rows={rowCount ? rowCount : "6"}
                        disabled={isDisabled}
                        {...field}
                    />
                )}
            />
            {invalid && <ValidationMsgComponent inputName={inputName} invalid={invalid} errors={errors} rules={rules}/>}
        </div>
    )
}

export default ControlledTextAreaField
